const baseElementUrl = document.querySelector('base').attributes.href.value;
const url = `${baseElementUrl}/ajax/UpdateMarketingCampaignPreferences`;

/**
 * Posts unsubscribe preferences to the server.
 * @param {{}} data
 * @param {boolean} data.newHomeInsider
 * @param {boolean} data.priceReduction
 * @param {boolean} data.newsletter
 * @param {boolean} data.nurture
 * @param {boolean} data.unsubscribeAll
 * @param {string} [data.anonymousId] - Segment's AnonymousId to be used when tracking events in the backend
 * @param {string} [data.email] - Email address the user wants to unsubscribe, only needed for guest users
 * @param {string} [data.confirmEmail] - Honeypot field for bot detection
 * @returns {Promise<any>}
 */
export default function postUnsubscribePreferences(data) {

  const payload = {
    UserEmail: data.email,
    ConfirmEmail: data.confirmEmail,
    OptInNewHomesInsider: data.newHomeInsider,
    OptInPriceReduction: data.priceReduction,
    OptInNewsletter: data.newsletter,
    OptInNurture: data.nurture,
    OptOutFromAll: data.unsubscribeAll,
    AnonymousId: data.anonymousId || null
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
}
